import { render, staticRenderFns } from "./ApproveReasonDialog.vue?vue&type=template&id=505365ac&scoped=true&"
import script from "./ApproveReasonDialog.vue?vue&type=script&lang=js&"
export * from "./ApproveReasonDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505365ac",
  null
  
)

export default component.exports